import React, {Suspense, lazy} from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// @ts-ignore
import reportWebVitals from './reportWebVitals';

//import css
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "aos/dist/aos.css";

//lazy import components to speed up content delivery
const NavBar = lazy(()=> import('./components/NavBar/NavBar'));
const Banner = lazy(()=> import('./components/Banner/Banner'));
const About = lazy(()=> import('./components/About/About'));
const FaqList = lazy(()=> import('./components/FaqList/FaqList'));
const ContactUs = lazy(()=> import('./components/ContactUs/ContactUs'));
const Product = lazy(()=>import('./components/Shop/ProductPage/ProductPage'));
const AllProductsList = lazy(()=>import('./components/Shop/AllProductList/AllProductsList'));
const Difference = lazy(()=>import('./components/Difference/Difference'));
const CheckoutResults = lazy(()=>import('./components/Checkout/CheckoutResults'))

//leave as any type
const rootElement:any = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Home page route */}
          <Route 
            path="/" 
            element={
              <Suspense>
                <NavBar />
                <Banner />
                <About />
                <Difference />
                <FaqList />
                <ContactUs />
              </Suspense>
            } 
          />


          {/* This page will show all current for sale products */}
          <Route
            path="/shop/all"
            element={
              <Suspense>
                <NavBar />
                <AllProductsList />
                <ContactUs />
              </Suspense>
            }
          />


          {/* Individual product page route */}
          <Route 
            path="/products/:productID" 
            element={
              <Suspense>
                <NavBar />
                <Product />
                <FaqList />
                <ContactUs />
              </Suspense>
            } 
          />

          <Route
            path="/shop/checkout/success"
            element={
              <Suspense>
                <NavBar />
                <CheckoutResults isSuccess={true} />
                <ContactUs />
              </Suspense>
            }
          />

          <Route
            path="/shop/checkout/failure"
            element={
              <Suspense>
                <NavBar />
                <CheckoutResults isSuccess={false} />
                <ContactUs />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
